var render = function render(){var _vm=this,_c=_vm._self._c;return _c('spinner',{attrs:{"line-fg-color":"#148898","line-bg-color":"#99bfbf","size":"large","message":_vm.message,"speed":1.5}})
}
var staticRenderFns = []

export { render, staticRenderFns }